import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEnvelope24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEnvelope24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 5.5H5a1.5 1.5 0 0 0-.44.066l7.445 7.444 7.442-7.442A1.5 1.5 0 0 0 19 5.5M3.5 7q0-.173.038-.335l5.37 5.371-5.356 5.357A1.5 1.5 0 0 1 3.5 17zm1.116 11.45q.184.05.384.05h14q.205 0 .393-.052l-5.353-5.352-1.505 1.505-.53.53-.53-.53-1.506-1.504zM15.1 12.035l5.35 5.35q.05-.185.05-.385V7q0-.17-.036-.328zM5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEnvelope24);
